import { useLocalStorage } from "@vueuse/core";

/**
 * The `id` of the newest Dealer News issue. Update it whenever an issue is
 * published; `dealer-news.nuxt.spec.ts` fails if it drifts from the first issue
 * on the page, which would leave readers without a notification.
 *
 * The value is opaque. It happens to look like a month today, but nothing
 * depends on that.
 */
const LATEST_NOTIFICATION_ID = "2026-10";

export function useDealerNews() {
  const latestNotification = useLocalStorage(
    "dealer-portal-latest-dealer-news",
    "",
  );
  function updateToLatestNotification() {
    latestNotification.value = LATEST_NOTIFICATION_ID;
  }
  // Ids are opaque, and this way a reader who saw an issue that was later
  // pulled still gets notified about whatever is newest now.
  const hasNewNotifications = computed(
    () => latestNotification.value !== LATEST_NOTIFICATION_ID,
  );
  return {
    LATEST_NOTIFICATION_ID,
    hasNewNotifications,
    updateToLatestNotification,
  };
}
